<template>
    <div class="flex flex-wrap justify-center text-center *:m-2">
        <small class="flex-[1_0_100%] text-[.875em]">Parteneri</small>
        <slot />
    </div>
</template>
